import Accordion from '@elementor/ui/Accordion';
import AccordionDetails from '@elementor/ui/AccordionDetails';
import AccordionSummary from '@elementor/ui/AccordionSummary';
import Box from '@elementor/ui/Box';
import Button from '@elementor/ui/Button';
import Typography from '@elementor/ui/Typography';
import { styled } from '@elementor/ui/styles';

export const StyledAccordion = styled(Accordion)`
	border-right: none;
	border-left: none;
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
	min-height: 44px;
	transition: 300ms ease-in-out;

	:hover {
		background-color: ${({ theme }) => theme.palette.action.hover};
		transition: 300ms ease-in-out;
	}

	.MuiAccordionSummary-expandIconWrapper path {
		fill: #0c0d0e;
	}

	& .MuiAccordionSummary-content {
		align-items: center;
		gap: ${({ theme }) => theme.spacing(1)};
		width: calc(100% - ${({ theme }) => theme.spacing(4)});
	}
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
	display: flex;
	flex-direction: column;

	gap: ${({ theme }) => theme.spacing(2)};
	padding-bottom: 0;
`;

export const StyledSnippet = styled(Typography)`
	word-break: break-word;
`;

export const StyledInfoTipBox = styled(Box)`
	max-width: 368px;

	padding: ${({ theme }) => theme.spacing(2)};

	white-space: normal;
`;

export const GetFreeInfoTipBox = styled(Box)`
	max-width: 376px;

	white-space: normal;
`;

export const StyledInfoTipDescriptionBox = styled(Box)`
	padding: ${({ theme }) => theme.spacing(2)};
`;

export const StyledInfoTipFooter = styled(Box)`
	display: flex;
	justify-content: flex-end;
	margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const StyledTitleBox = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: center;

	margin-bottom: ${({ theme }) => theme.spacing(0.5)};
	gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const StyledFrame = styled(Box)`
	padding: 12px;

	border: 1px solid ${({ theme }) => theme.palette.divider};

	border-radius: 4px;
`;

export const StyledFrameText = styled(Typography)`
	display: flex;
	align-items: baseline;

	gap: ${({ theme }) => theme.spacing(0.5)};
	margin-bottom: ${({ theme }) => theme.spacing(1)};

	color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledIssueResolveHeading = styled(Typography)`
	display: flex;
	align-items: center;

	margin: 0;
	margin-bottom: ${({ theme }) => theme.spacing(1)};
	gap: ${({ theme }) => theme.spacing(0.5)};

	font-size: 14px;
	font-weight: 500;
`;

export const StyledExampleLink = styled(Button)`
	font-size: 14px;
	letter-spacing: 0.17px;
	text-decoration: none;
`;
